import { ReactElement } from 'react';
import { ValueType } from 'react-select';
import { Header } from '@designSystem/typings';
import Lang from '@lang/en';
import Button from '@root/src/app/designSystem/buttons';
import { CloseMark } from '@root/src/assets/images';
import DropDown from '@designSystem/dropDown';
import { SelectOption } from '@app/common/types';
import {
  ActionRow,
  HeaderRow,
  MobileContainer,
  MobileInput,
  MobileInputRow,
  StyledMobileDropDownWrapper,
} from './styles';
import { EditOrderProps } from './editOrder';

const EditOrderMobileOrder = ({
  handleClose,
  handleSaveOrderInformation,
  orderRegisteredFields,
  errors,
  handleChangeTestType,
  currentValueTestType,
  testTypes,
}: EditOrderProps): ReactElement => {
  const handleSubmit = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    handleSaveOrderInformation && handleSaveOrderInformation(event);
  };

  return (
    <MobileContainer>
      <HeaderRow>
        <Header data-testid="healthcheck-order-edit-modal-header">
          {Lang.healthCheckEditOrderLabel}
        </Header>
        <CloseMark onClick={handleClose} />
      </HeaderRow>
      <MobileInputRow isActive>
        <StyledMobileDropDownWrapper>
          <DropDown
            data-testid="healthcheck-mobile-order-edit-modal-test-type"
            options={testTypes}
            onChange={(e: ValueType<SelectOption, false>): void =>
              handleChangeTestType(e)
            }
            label={Lang.healthCheckEditOrderTypeLabel}
            value={currentValueTestType}
          />
        </StyledMobileDropDownWrapper>
        <MobileInput
          registered={orderRegisteredFields?.referenceCodeField}
          label={Lang.healthCheckEditOrderOtherRefNumberLabel}
          errorMessage={errors?.referenceCode?.message}
          disabled
        />
        <MobileInput
          registered={orderRegisteredFields?.barcodeNumberField}
          label={Lang.healthCheckEditOrderOtherBarcodeNumberLabel}
          errorMessage={errors?.barcodeNumber?.message}
        />
      </MobileInputRow>
      <ActionRow>
        <Button onClick={handleClose} type="tertiary" label={Lang.cancelText} />
        <Button
          data-testid="healthcheck-order-edit-modal-save-button"
          onClick={(event) => handleSubmit(event)}
          label={Lang.saveText}
        />
      </ActionRow>
    </MobileContainer>
  );
};

export default EditOrderMobileOrder;
